import type { LexicalEditor } from "lexical";
import { exportToMarkdownV2 } from "@tgpe/editor-core";

/**
 * Render the current editor state as Telegram MarkdownV2 and put it on
 * the system clipboard. Used when the host Telegram client is too old
 * to support `WebApp.shareMessage` directly.
 *
 * Throws on clipboard failure so the caller can surface an error toast.
 */
export async function copyAsMarkdownV2(editor: LexicalEditor): Promise<void> {
  const markdown = exportToMarkdownV2(editor.getEditorState());
  await navigator.clipboard.writeText(markdown);
}
